'use client';

import {
  PropsWithChildren,
  useState,
  createContext,
  Dispatch,
  SetStateAction,
} from 'react';

import { defaultNonIntlFolders, locales } from '@monoimin/constants';

import { NonIntlFolders, ByLocales, Locales } from '@monoimin/sb-types';

type Alternates = ByLocales<Locales, string>;

export type AlternatePageState = {
  alternates: Alternates;
  nonIntlFolders: NonIntlFolders;
};

type AlternatePageContextValue = [
  AlternatePageState,
  Dispatch<SetStateAction<AlternatePageState>>
];

const defaultAlternates = locales.reduce<Alternates>((acc, locale) => {
  return {
    ...acc,
    [locale]: '',
  };
}, {} as Alternates);

export const defaultState: AlternatePageState = {
  alternates: defaultAlternates,
  nonIntlFolders: defaultNonIntlFolders,
};

export const AlternatePageContext = createContext<AlternatePageContextValue>([
  defaultState,
  () => undefined,
]);

export const AlternatePageProvider = ({
  children,
  nonIntlFolders,
}: PropsWithChildren<{
  nonIntlFolders: NonIntlFolders;
}>) => {
  const [state, setState] = useState<AlternatePageState>({
    alternates: defaultState.alternates,
    nonIntlFolders: nonIntlFolders,
  });

  return (
    <AlternatePageContext.Provider value={[state, setState]}>
      {children}
    </AlternatePageContext.Provider>
  );
};

export default AlternatePageProvider;
